import { HttpService, HttpServiceResponse } from '../shared'
import { SystemActions } from './system.constants'
import { SystemInfoServerData, SystemActiveUsersServerData } from './system.types'

export class SystemProvider {
  constructor(private http: HttpService, private baseUrl: string) {}

  private get url(): string {
    return `${this.baseUrl}/sysinfo_view_api.php`
  }

  public info(): Promise<HttpServiceResponse<SystemInfoServerData>> {
    return this.http.post(`${this.url}?action=${SystemActions.Database}`)
  }

  public activeUsers(): Promise<HttpServiceResponse<SystemActiveUsersServerData>> {
    return this.http.post(`${this.url}?action=${SystemActions.ActiveUsers}`)
  }
}
